<template>
  <article class="product type-product">
    <div class="info">
      <span>
        <a :href="productUrl"  data-title="Quick wiew" preserve-state><i class="icon icon-eye"></i></a>
      </span>
    </div>
    <div class="figure-grid">
      <div class="image">
        <a :href="productUrl" preserve-state>
          <div class="custom-labels-wrapper position-top" v-if="product.special_price || product.badge || (product.campaign.length > 0 && product.campaign[0].badge)">
            <span class="label label-sale label-warning top-left" v-if="product.special_price || product.campaign.length > 0" v-html="this.$trans('theme::product_card.promo')"></span>
            <template v-for="badge in product.badge">
              <span class="label label-sale label-warning" v-if="badge.position == 'top-left' || badge.position == 'top-right'" v-html="badge.name" :style="{ 'background-color' : badge.background_color, color : badge.text_color}" :class="badge.position"></span>
            </template>
            <template v-if="product.campaign.length > 0 && product.campaign[0].badge">
              <span class="label label-sale label-warning" v-if="product.campaign[0].badge.position == 'top-left' || product.campaign[0].badge.position == 'top-right'" v-html="product.campaign[0].badge.name" :style="{ 'background-color' : product.campaign[0].badge.background_color, color : product.campaign[0].badge.text_color}" :class="product.campaign[0].badge.position"></span>
            </template>
          </div>

          <div class="custom-labels-wrapper position-bottom" v-if="product.badge || (product.campaign.length > 0 && product.campaign[0].badge)">
            <template v-for="badge in product.badge">
              <span class="label label-sale label-warning" v-if="badge.position == 'bottom-left' || badge.position == 'bottom-right'" v-html="badge.name" :style="{ 'background-color' : badge.background_color, color : badge.text_color}" :class="badge.position"></span>
            </template>
            <template v-if="product.campaign.length > 0 && product.campaign[0].badge">
              <span class="label label-sale label-warning" v-if="product.campaign[0].badge.position == 'bottom-left' || product.campaign[0].badge.position == 'bottom-right'" v-html="product.campaign[0].badge.name" :style="{ 'background-color' : product.campaign[0].badge.background_color, color : product.campaign[0].badge.text_color}" :class="product.campaign[0].badge.position"></span>
            </template>
          </div>

          <img :src="product.base_image.small" :class="{ 'image-placeholder': ! hasBaseImage }" loading="lazy" alt="product image">
        </a>
      </div>
      <div class="text">
        <a :href="productUrl" preserve-state>
          <div class="additional-badges">
            <span class="label label-black" v-if="product.fast_delivery" v-html="this.$trans('theme::product_card.fast_delivery')"></span></div>
          <p class="title">{{ product.name }}</p>
          <ProductRating :ratingPercent="product.rating_percent" :reviewCount="reviewCount"/>
          <span class="price product-price product-price-clone notranslate" v-html="product.formatted_price"></span>


        </a>
        <div class="add-to-cart">
          <a
          v-if="hasAnyOption || hasAnyVariant"
          :href="productUrl"
          class="button product_type_simple add_to_cart_button"
          preserve-state
          >
            {{this.$trans('product::product.add_to_cart_configure')}}
          </a>

          <a
          v-else
          class="button product_type_simple add_to_cart_button"
          :class="{ 'btn-loading': addingToCart }"
          :disabled="product.is_out_of_stock"
          @click="addToCart"
          >
            {{this.$trans('product::product.add_to_cart')}}
          </a>
        </div>
        <div class="product-bottom-informations">
          <div class="colours"></div>
          <div class="dimensions">
            <span v-if="product.size" v-html="product.size">
            </span>
          </div>
        </div>
      </div>

    </div>
  </article>
</template>

<script>
    import ProductRating from './ProductRating.vue';
    import ProductCardMixin from '../mixins/ProductCardMixin';

    export default {
        components: { ProductRating },

        mixins: [
            ProductCardMixin,
        ],

        props: ['product'],
    };
</script>
